/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DefaultService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Health Check
   * @returns string OK
   * @throws ApiError
   */
  public getPing(): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ping',
    });
  }

  /**
   * Health Check
   * @returns string OK
   * @throws ApiError
   */
  public getDevicePing(): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/device/ping',
    });
  }
}
